var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgIcEye24 = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3.897 11.518C4.759 9.872 7.287 6 12 6c4.759 0 7.256 3.855 8.108 5.516.156.305.154.662-.005.966C19.241 14.128 16.713 18 12 18c-4.759 0-7.256-3.855-8.108-5.516a1.04 1.04 0 0 1 .005-.966M8.77 12c0 1.84 1.447 3.333 3.23 3.333S15.23 13.84 15.23 12q0-.305-.051-.595a1.83 1.83 0 0 1-1.346.595c-1.026 0-1.859-.859-1.859-1.918 0-.537.214-1.022.558-1.37A3 3 0 0 0 12 8.667c-1.783 0-3.23 1.493-3.23 3.333",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcEye24);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };